import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

const ApplyButton = ({ onClick, disabled }: Props) => {
  const t = useTranslations("ui");

  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="bg-black rounded-full w-full max-w-[119px] h-[48px]"
    >
      {t("apply")}
    </Button>
  );
};

export default ApplyButton;
